/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-icn[_ngcontent-%COMP%]{width:10%;height:2vh;margin:20px;fill:#969da1}.btn-icn.selected[_ngcontent-%COMP%]{fill:rgba(0,0,0,.87)}.bar[_ngcontent-%COMP%]{height:6vh;width:100%;margin:0 auto}"];
export { styles as styles };
